import { NgModule } from '@angular/core';
import { NotFoundComponent } from './not-found.component';

@NgModule({
  declarations: [NotFoundComponent],
  imports: [],
  exports: [],
  providers: [],
})
export class NotFoundModule {}
